import {Injectable} from "@angular/core";
import {TrackableEntityActionService} from "./trackable-entity-action.service";
import {HttpClient} from "@angular/common/http";
import {NavigationService} from "./navigation.service";
import {Router} from "@angular/router";
import {CommonService} from "./common.service";
import {UserService} from "./user.service";
import {environment} from "../../../environments/environment";
import {FirebaseEventEnum} from "../enum/firebase-event.enum";
import {FirebaseService} from "./firebase.service";
import {Place} from "../model/place.model";
import {PageResponseDTO} from "../model/page-response.model";
import {EventDTO} from "../model/event.model";
import {map} from "rxjs/operators";

@Injectable(
  {providedIn: 'root'}
)
export class PlaceActionService extends TrackableEntityActionService<Place<any>> {

  constructor(private firebaseService: FirebaseService,
              http: HttpClient,
              navigationService: NavigationService,
              router: Router,
              commonService: CommonService,
              userService: UserService) {

    super(http, navigationService, router, userService, commonService, environment.host + "/users/actions/places");
  }

  getFavoritePlacesIds() {
    return this.http.get<number[]>(environment.host + "/users/me/places/favorite");
  }

  public override countCalendarFB(event: Place<any>) {
    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'add-calendar'
    });
  }

  public override countOpenFB(event: Place<any>) {
    console.error("Method not implemented. - EventActionService.countOpenFB");
  }

  public override countCallFB(event: Place<any>) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'call-number'
    });
  }

  public override countWhatsappFB(event: Place<any>) {
    console.error("Method not implemented. - EventActionService.countWhatsappFB");
  }

  public override countNavigateFB(event: Place<any>) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'navigate'
    });
  }

  public override countInstagramFB(event: Place<any>) {
    console.error("Method not implemented. - EventActionService.countInstagramFB");
  }

  public override countFacebookFB(event: Place<any>) {
    console.error("Method not implemented. - EventActionService.countFacebookFB");
  }

  public override countExternalLinkFB(event: Place<any>) {
    console.error("Method not implemented. - EventActionService.countExternalLinkFB");
  }

  public override countShareFB(event: Place<any>) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'share'
    });

  }

  public override toggleFavoriteFB(event: Place<any>) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'favorite'
    });

  }

}
